import { actions, paths } from "../../../../common/constants";

export default {
  getCustomers: ({
    asc = false,
    orderBy = "createdAt",
    limit = 10,
    start_at = 1,
    keyword,
  }) => ({
    [actions.CALL_API]: {
      types: [
        actions.GET_CUSTOMERS_REQUEST,
        actions.GET_CUSTOMERS_SUCCESS,
        actions.GET_CUSTOMERS_FAILURE,
      ],
      promise: (client) =>
        client.get(paths.api.v1.CUSTOMERS, {
          params: { asc, orderBy, limit, start_at, keyword },
        }),
    },
  }),

  createCustomer: (customerData) => ({
    [actions.CALL_API]: {
      types: [
        actions.CUSTOMER_CREATE_REQUEST,
        actions.CUSTOMER_CREATE_SUCCESS,
        actions.CUSTOMER_CREATE_FAILURE,
      ],
      promise: (client) =>
        client.post(paths.build(paths.api.v1.CUSTOMERS), customerData),
    },
  }),

  disconnectCustomer: (customer_id) => ({
    [actions.CALL_API]: {
      types: [
        actions.CUSTOMER_DISCONNECT_REQUEST,
        actions.CUSTOMER_DISCONNECT_SUCCESS,
        actions.CUSTOMER_DISCONNECT_FAILURE,
      ],
      promise: (client) =>
        client.post(paths.build(paths.api.v1.STRIPE_DISCONNECT), {
          customer_id,
        }),
    },
  }),

  getCustomerDetail: (id) => ({
    [actions.CALL_API]: {
      types: [
        actions.GET_CUSTOMER_DETAIL_REQUEST,
        actions.GET_CUSTOMER_DETAIL_SUCCESS,
        actions.GET_CUSTOMER_DETAIL_FAILURE,
      ],
      promise: (client) =>
        client.get(paths.build(paths.api.v1.CUSTOMERS_ID, id)),
    },
  }),

  deleteCustomer: (id) => ({
    [actions.CALL_API]: {
      types: [
        actions.CUSTOMER_DELETE_REQUEST,
        actions.CUSTOMER_DELETE_SUCCESS,
        actions.CUSTOMER_DELETE_FAILURE,
      ],
      promise: (client) =>
        client.delete(paths.build(paths.api.v1.CUSTOMERS_ID, id)),
    },
  }),

  updateCustomer: (id, customerData) => {
    const query = new FormData();
    for (let key in customerData) {
      query.append(key, customerData[key]);
    }

    return {
      [actions.CALL_API]: {
        types: [
          actions.CUSTOMER_UPDATE_REQUEST,
          actions.CUSTOMER_UPDATE_SUCCESS,
          actions.CUSTOMER_UPDATE_FAILURE,
        ],
        promise: (client) =>
          client.put(paths.build(paths.api.v1.CUSTOMERS_ID, id), query),
      },
    };
  },

  resetPassword: ({ customer_id, password }) => ({
    [actions.CALL_API]: {
      types: [
        actions.CUSTOMER_RESET_PASSWORD_REQUEST,
        actions.CUSTOMER_RESET_PASSWORD_SUCCESS,
        actions.CUSTOMER_RESET_PASSWORD_FAILURE,
      ],
      promise: (client) =>
        client.post(paths.build(paths.api.v1.CUSTOMER_RESET_PASSWORD), {
          customer_id,
          password,
        }),
    },
  }),

  getPostsByUserID: ({
    asc = false,
    orderBy = "createdAt",
    limit = 10,
    start_at = 1,
    keyword,
    customer_id,
    deleted = "false",
  }) => ({
    [actions.CALL_API]: {
      types: [
        actions.GET_POST_ITEMS_REQUEST,
        actions.GET_POST_ITEMS_SUCCESS,
        actions.GET_POST_ITEMS_FAILURE,
      ],
      promise: (client) =>
        client.post(paths.api.v1.POSTS, {
          asc,
          orderBy,
          limit,
          start_at,
          keyword,
          customer_id,
          deleted,
        }),
    },
  }),
};



// WEBPACK FOOTER //
// ./client/react/Admin/actions/customers.js